import { Button } from "components/Button";
import { EXTRALARGE, SMALL, GREY } from "shared/variables";
import { MaxWidth } from "components/MaxWidth";
import { Page } from "components/Page";
import { PageTitleWithLabel } from "components/PageTitleWithLabel";
import { ReviewCard } from "components/ReviewCard";
import { ReviewsSummaryBar } from "components/ReviewsSummaryBar";
import { SpacingSection } from "components/SpacingSection";
import { useEffect, useState } from "react";

const reviewsPerPage = 12;

export const ReviewsPage = ({ doc, staticReviews, preview }) => {
  const reviews = useReviews({ uid: doc.uid, initialValue: staticReviews });
  const [page, setPage] = useState(1);

  const reviewScores = (reviews || []).map(({ score }) => parseInt(score, 10));
  const reviewsAmount = reviewScores.length;
  const reviewsRating = reviewScores.reduce((a, b) => a + b, 0) / reviewsAmount;
  const renderButton = page * reviewsPerPage < reviews.length;

  const { type, uid } = doc;
  const { hero_title, seo_title, seo_description, seo_image } = doc.data;

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      preview={preview}
    >
      <SpacingSection size={EXTRALARGE}>
        <MaxWidth>
          <PageTitleWithLabel
            title="Reviews en beoordelingen"
            label={hero_title?.replace(/\*/g, "")}
            link={{ type, uid }}
          />
          <SpacingSection size={SMALL}>
            <ReviewsSummaryBar
              rating={reviewsRating}
              amount={reviewsAmount}
              type={doc.type}
              uid={doc.uid}
            />
          </SpacingSection>
          {reviews
            .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
            .slice(0, page * reviewsPerPage)
            .map(({ createdAt, name, message, score }, index) => (
              <SpacingSection key={index} size={SMALL}>
                <ReviewCard
                  createdAt={createdAt}
                  message={message}
                  name={name}
                  rating={score}
                />
              </SpacingSection>
            ))}
          {renderButton && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button color={GREY} onClick={() => setPage(page + 1)}>
                Toon meer
              </Button>
            </div>
          )}
        </MaxWidth>
      </SpacingSection>
    </Page>
  );
};

function useReviews({ uid, initialValue }) {
  const [reviews, setReviews] = useState(initialValue);

  useEffect(() => {
    const fetchReviews = async () => {
      const { reviews } = await fetch(`/api/reviews?uid=${uid}`).then((r) =>
        r.json()
      );

      setReviews(reviews || []);
    };

    fetchReviews();
  }, [uid]);

  return reviews;
}
